var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DateRangePicker',{attrs:{"value":_vm.rangeValue,"single":"","variant":_vm.variant,"presets":false,"disabled":_vm.disabled},on:{"input":_vm.onInput}})}
var staticRenderFns = []

export { render, staticRenderFns }